import React, { PureComponent, Component } from 'react'
import { withFirebase, firebaseConnect } from 'react-redux-firebase'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { styles } from './dockPadStyle'
import { dockPadEntityMapToList } from './DockPadFormTemplates'
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import { homeActions } from '../actions/home.actions'
import { userActions } from '../actions/user.actions'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import { Select, MenuItem, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core'
import { Roles } from '../utils/Roles'
import { getProjectUsers, getProjectRoles, getProjectId, getInvitedUsers, getProjectUsersTableFormatted } from '../selectors/project.selector'
import { getCurrentUserId, getCurrentUserRole } from '../selectors/user.selector'
import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit'

import MaterialTable from 'material-table'
import { dialogActions } from '../actions/dialog.actions'
import Input from '@material-ui/core/Input';
import { TextMaskCustom } from '../components/TextMaskCustom'
import SaveIcon from '@material-ui/icons/Save';
import InviteDialog from '../components/Dialogs/InviteDialog';
import DeleteIcon from '@material-ui/icons/Delete';
import { ThunkDispatch } from 'redux-thunk'

import parsePhoneNumber from 'libphonenumber-js'

class TeamScreen extends Component {
  state = {
    userChanges: {},
    deleteUserOpen: null,

    deleteInviteOpen:  null
  }

  renderInviteTableContainer() {
    const { classes } = this.props
    return (
      <React.Fragment>

          {this.renderMemberTable()}
        <Typography
          className={classNames(classes.sectionPaperHeader)}
          variant='headline'
          noWrap>
          Invited Users
        </Typography>
        <Paper
          className={classNames(
            classes.profilePaper,
            classes.taskTableContainer
          )}>
          {this.renderInvitedTable()}
        </Paper>
      </React.Fragment>
    )
  }

  updateUserRole(row, event) {
    const { dispatch, projectId } = this.props

    dispatch(userActions.changeUserRole(projectId, row.uid, event.target.value))
  }

  decideRole(role) {
    if (!role) {
      return Roles.ADMIN
    } else {
      return role.type
    }
  }
  renderRolesDropDown(row) {
    const { currentUserId, currentUserRole } = this.props
    const role = this.decideRole(row.role)

    if (row.uid === currentUserId) {
      return role
    }

    if (currentUserRole !== Roles.ADMIN) {
      return role
    }

    return (
      <Select
        value={role}
        onChange={event => {
          this.updateUserRole(row, event)
        }}>
        <MenuItem value={Roles.ADMIN}>Admin</MenuItem>
        <MenuItem value={Roles.COLLABORATOR}>Collaborator</MenuItem>
        <MenuItem value={Roles.VIEWER}>Viewer</MenuItem>
      </Select>
    )
  }

  isValidNumber(user) {
    if(!user) return false

    const { phoneNumber } = user

    if(!phoneNumber) return false

    const parsedNumber = parsePhoneNumber(phoneNumber)


    if(!parsedNumber) return false

    return parsedNumber.isValid()
  }

  formatPhoneNumber = (str:string) => {
    //Filter only numbers from the input
    let cleaned = ('' + str).replace(/\D/g, '');
    
    //Check if the input is of correct
    let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    
    if (match) {
      //Remove the matched extension code
      //Change this to format for any country code.
      let intlCode = (match[1] ? '+1 ' : '')
      return ['(', match[2], ') ', match[3], '-', match[4]].join('')
    }
    
    return null;
    }

  renderPhoneNumber(rowData) {
    const { currentUserId, currentUserRole, classes, savePhoneNumber } = this.props

    if (currentUserRole !== Roles.ADMIN || currentUserId !== rowData.uid) {
      return rowData.phoneNumber
    }

    const validNumber = this.isValidNumber(this.state.userChanges[rowData.uid])

    const fullLength = (!!this.state.userChanges[rowData.uid] && !!this.state.userChanges[rowData.uid].phoneNumber) ? this.state.userChanges[rowData.uid].phoneNumber.length : 0


    const isFullLength = fullLength == 12
    return (
      <div style={{display: 'flex', flexDirection: 'row'}}>
        {validNumber && <IconButton
          onClick={() => {
            savePhoneNumber(currentUserId, this.state.userChanges[rowData.uid].phoneNumber)
          }}>
          <SaveIcon
            className={classNames(classes.AllTasksScreenVisibilityIcon)}
          />
        </IconButton>
        }
        <Input
          defaultValue={rowData.phoneNumber}
          onChange={async (event) => {
            const { userChanges } = this.state

            const phoneNumber = !!parsePhoneNumber(event.target.value) ? parsePhoneNumber(event.target.value).number : '+1'
            userChanges[rowData.uid] = {
              phoneNumber: phoneNumber
            }
            this.setState({
              userChanges
            })

          }}
          error={!this.isValidNumber(this.state.userChanges[rowData.uid]) && isFullLength}
          id="formatted-text-mask-input"
          inputComponent={TextMaskCustom}
        />

      </div>
    )  
  }



  renderInvitedUser(row) {
    const { classes, currentUserRole } = this.props

    return (
      <TableRow key={row.uid}>
        <TableCell>{Roles.ADMIN != currentUserRole &&<IconButton
        onClick={() => {
          this.handleClickInviteDeleteDialogOpen(row)
        }}>
        <DeleteIcon
          className={classNames(classes.AllTasksScreenVisibilityIcon)}
        />
      </IconButton>}</TableCell>
        <TableCell>{row.user_email}</TableCell>
      </TableRow>
    )
  }

  renderEditButton(rowData) {
    const { dispatch, classes, currentUserRole } = this.props
    if (Roles.ADMIN !== currentUserRole) return

    return (
      <IconButton
        onClick={() => {

          
        }}>
        <SaveIcon
          className={classNames(classes.AllTasksScreenVisibilityIcon)}
        />
      </IconButton>
    )
  }

  renderDeleteButton(rowData: { uid: any }) {
    const { dispatch, classes, currentUserRole, deleteUser, currentUserId } = this.props
    if (Roles.ADMIN !== currentUserRole) return

    if(currentUserId == rowData.uid) return

    return (
      <IconButton
        onClick={() => {
          this.handleClickUserDeleteDialogOpen(rowData)
          //dispatch(dialogActions.openProjectUserDialog())
        }}>
        <DeleteIcon
          className={classNames(classes.AllTasksScreenVisibilityIcon)}
        />
      </IconButton>
    )
  }

  renderMemberTable() {
    return (
      <MaterialTable
        columns={[
          {
            title: '',
            field: 'delete',
            cellStyle: {
              backgroundColor: '#f9fcfd',
              padding: '4px'
            },
            headerStyle: {
              padding: '4px'
            },
            render: rowData => {
              return this.renderDeleteButton(rowData)
            }
          },
          {
            title: 'Name',
            field: 'name',
            cellStyle: {
              backgroundColor: '#f9fcfd'
            }
            
          },
          {
            title: 'Email',
            field: 'email',
            cellStyle: {
              backgroundColor: '#f9fcfd'
            }
          },
          {
            title: 'Phone Number',
            field: 'phoneNumber',
            cellStyle: {
              backgroundColor: '#f9fcfd'
            },
            render: rowData => {
              return this.renderPhoneNumber(rowData)
            }
          },
          {
            title: 'Role',
            field: 'role',
            cellStyle: {
              backgroundColor: '#f9fcfd'
            },
            render: rowData => {
              return this.renderRolesDropDown(rowData)
            }
          },
        ]}
        data={this.props.teamTableData}
        title=''>

      </MaterialTable>
    )
  }

  renderInvitedTable() {

    let invitedUsers = dockPadEntityMapToList(this.props.invitedUsers).filter(user => {
      return (user.project_uid === this.props.projectId)
    })

    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>

            <TableCell>Email</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{invitedUsers.map(row => this.renderInvitedUser(row))}</TableBody>
      </Table>
    )
  }

  onInviteClick() {
    const { dispatch } = this.props
    dispatch(homeActions.openInviteDialog())
  }

  renderInviteButton() {
    const { currentUserRole } = this.props
    if (Roles.VIEWER === currentUserRole) return

    return <Button
        onClick={this.onInviteClick.bind(this)}
        variant='outlined'
        color='primary'>
        Invite
      </Button>
  }

  handleClickUserDeleteDialogOpen = (user: any) => {
    this.setState({deleteUserOpen: user})
  };

  handleClickInviteDeleteDialogOpen = (invite: any) => {
    this.setState({deleteInviteOpen: invite})
  };

  handleDeleteUserClose = () => {
    this.setState({deleteUserOpen: null})

  };

  handleDeleteInviteClose = () => {
    this.setState({deleteInviteOpen: null})
  }

  handleDeleteUser = () => {
    const { deleteUserOpen} = this.state
    const { deleteUser } = this.props


    deleteUser(deleteUserOpen)
    this.handleDeleteUserClose()
  } 

  handleDeleteInvite = () => {
    const { deleteInviteOpen } = this.state
    const { deleteInvite } = this.props


    deleteInvite(deleteInviteOpen)
    this.handleDeleteInviteClose()
  }

  render() {
    const { classes } = this.props

    const {deleteUserOpen, deleteInviteOpen } = this.state

    return (
      <React.Fragment>
        <Dialog
          open={!!this.state.deleteUserOpen}
          onClose={this.handleDeleteUserClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Remove User"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to remove {!!deleteUserOpen ? deleteUserOpen.name : ""}?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDeleteUserClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleDeleteUser} color="error" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={!!this.state.deleteInviteOpen}
          onClose={this.handleDeleteInviteClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Remove User"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to remove the invite to {!!deleteInviteOpen ? deleteInviteOpen.user_email : ""}?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDeleteInviteClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleDeleteInvite} color="error" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <div className={classNames(classes.pageContainer)}>
          <InviteDialog />

          <Typography
            className={classNames(classes.sectionPaperHeader)}
            variant='headline'
            noWrap>
            Team
          </Typography>
          <div className={classNames(classes.profilePaperTitle)}>
            {this.renderInviteButton()}
          </div>
          {this.renderInviteTableContainer()}
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state:any) => ({
  invitedUsers: getInvitedUsers(state),
  projectUsers: getProjectUsers(state) ,
  roles: getProjectRoles(state),
  currentUserId: getCurrentUserId(state),
  currentUserRole: getCurrentUserRole(state),
  projectId: getProjectId(state),
  teamTableData: getProjectUsersTableFormatted(state)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

  return {
    deleteUser: (userId:string) => dispatch(userActions.deleteUser(userId)),
    deleteInvite: (inviteId:string) => dispatch(userActions.deleteInvite(inviteId)),
    savePhoneNumber: (userId: string, phoneNumber: string) => dispatch(userActions.savePhoneNumber(userId, phoneNumber))
  }
};

export default compose(
  withRouter,
  withFirebase,
  connect((state, props) => {
    return {
      projectId: getProjectId(state)
    }
  }),
  firebaseConnect(props => {
    return [
      {
        path: 'user_invites',
        storeAs: 'APP_INVITES'
      }
    ]
  }),


  connect(mapStateToProps, mapDispatchToProps),

  withStyles(styles, { withTheme: true })
)(TeamScreen)

function isPhoneNumberValid(p) {
  var phoneRe = /^[2-9]\d{2}[2-9]\d{2}\d{4}$/;
  var digits = p.replace(/\D/g, "");
  return phoneRe.test(digits);
}


// WEBPACK FOOTER //
// ./src/containers/TeamScreen.tsx